// extracted by mini-css-extract-plugin
module.exports = {"header":"i_s","back":"i_t","description":"i_u","with-back-button":"i_v"};